module.exports = __webpack_public_path__ + "img/编组 9@2x.972ffc7a.png";